import {DataLayerTracker} from './datalayer';
import {YandexMetrika} from './yandex-metrika';

/**
 * На бекенде инициализируется набор данных для аналитики. Будем использовать его в качестве контейнера для хранения
 * данных и будем раздавать оттуда данные для аналитических сервисов и CPA партнеров
 */
export class Tracker {
    constructor(data) {
        this.data = data;
        this.dataLayer = new DataLayerTracker(data);
        this.yandexMetrika = new YandexMetrika();

        this.init();
        this.backendPageViewed();
    }

    init() {
        this.dataLayer.init();
    }


    backendPageViewed() {
        try {
            switch (this.data.route) {
                case 'index':
                    this.indexPageViewed();
                    break;
                case 'catalog':
                    this.catalogPageViewed();
                    break;
                case 'catalog_products':
                    this.categoryPageViewed();
                    break;
                case 'catalog_product':
                    this.productPageViewed();
                    break;
                case 'cart':
                    this.cartPageViewed();
                    break;
                case 'order':
                    this.orderPageViewed();
                    break;
                // это фейковый маршрут, но страница эта отдельная
                case 'order.thankyoupage':
                    this.orderThankyouPageViewed();
                    break;
                default:
                    this.otherPageViewed();
                    break;
            }
        } catch (e) {
            console.log(e);
        }
    }


    otherPageViewed() {

    }

    indexPageViewed() {
        this.dataLayer.categoryPageView(this.data.products);
    }

    catalogPageViewed() {
        this.dataLayer.categoryPageView(this.data.products);
    }

    categoryPageViewed() {
        this.dataLayer.categoryPageView(this.data.products);
    }

    productPageViewed() {
        this.dataLayer.productPageView(this.data.product);
    }

    cartPageViewed() {
        this.dataLayer.cartPageView(this.data.basket);
    }

    orderPageViewed() {
        this.dataLayer.orderPageView(this.data.basket);
    }

    /**
     *  Вот это по сути страница оплаты
     */
    orderThankyouPageViewed() {
        this.dataLayer.orderThankyouPageView(this.data.order, this.data.basket);
    }


    /*basketItemAddClicked() {
        this.dataLayer.push({'event': 'Add2Cart_Button'});
    }*/


    /**
     *  рабочий
     *  window.emiliadelloroShopTracker.basketItemAdded(product);
     * @param product
     */
    basketItemAdded(product) {
        this.dataLayer.basketItemAdd(product);
    }

    basketItemRemoved(product) {
        this.dataLayer.basketItemRemove(product);
    }

    catalogProductClick(product = {}) {
        if (product.length === 0) {
            console.log('Error push dataLayer catalogProductClick: empty data product');
            return;
        }
        this.dataLayer.catalogProductClick(product);
    }

    isUserAuthorized() {
        return this.data.user.authorized;
    }

    getCurrency() {
        return this.data.currency;
    }

}



// WEBPACK FOOTER //
// ./modules/tracker/tracker.js